export namespace Config {
  export const GOOGLE_CLIENT_ID =
    "803179001796-q4gnhnmg1sigof544gf49nehhneo992d.apps.googleusercontent.com";
  export const GOOGLE_SCOPES = [
    "https://www.googleapis.com/auth/calendar.readonly",
    "https://www.googleapis.com/auth/calendar.events",
    "https://www.googleapis.com/auth/userinfo.email",
    "https://www.googleapis.com/auth/userinfo.profile",
  ];
  export const GOOGLE_SCOPES_WITH_CALENDAR = [
    "https://www.googleapis.com/auth/calendar",
    "https://www.googleapis.com/auth/calendar.events",
    "https://www.googleapis.com/auth/calendar.events.owned",
    "https://www.googleapis.com/auth/userinfo.email",
    "https://www.googleapis.com/auth/userinfo.profile",
  ];

  // Entra app registration (application/client id — public, like
  // GOOGLE_CLIENT_ID above). Outlook auth surfaces hide themselves
  // while it is empty.
  // Typed `string` (not the literal) so `isConfigured()`-style empty
  // checks stay valid whichever value is present.
  export const OUTLOOK_CLIENT_ID: string =
    "1379263e-7dd5-4808-aa84-1d085c4c42a9";
  // MUST stay in lockstep with tento-outlook's `oauth.rs::SCOPE` — the
  // token exchange re-presents the same scope string.
  export const OUTLOOK_SCOPES = "offline_access User.Read Calendars.ReadWrite";
}
